import {testIdProps} from '@github-ui/test-id-props'
import {memo} from 'react'
import type {ColumnInstance} from 'react-table'

import type {MemexItemModel} from '../../models/memex-item-model'
import {useVisiblePagination} from '../common/use-visible-pagination'
import {StyledTableCell} from './table-cell'
import {useTableInstance} from './table-provider'
import {StyledTableRow, tableRowStyle} from './table-row'

export const PLACEHOLDER_ROW_COUNT = 5

export const TablePagination: React.FC<{groupId?: string}> = ({groupId}) => {
  const {ref, hasNextPage} = useVisiblePagination({groupId})
  const {visibleColumns} = useTableInstance()

  return (
    <div ref={ref} {...testIdProps(`table-pagination${groupId ? `-${groupId}` : ''}`)}>
      {!hasNextPage
        ? null
        : [...Array(PLACEHOLDER_ROW_COUNT).keys()].map(key => <PlaceholderRow key={key} columns={visibleColumns} />)}
    </div>
  )
}

type PlaceholderRowProps = {
  columns: Array<ColumnInstance<MemexItemModel>>
}

const PlaceholderRowUnmemoized: React.FC<PlaceholderRowProps> = ({columns}) => {
  return (
    <StyledTableRow role="row" style={{...tableRowStyle}} {...testIdProps('placeholder-row')}>
      {columns.map(column => (
        <StyledTableCell key={column.id} role="gridcell" style={{whiteSpace: 'nowrap', width: column.width}}>
          {column.Placeholder}
        </StyledTableCell>
      ))}
    </StyledTableRow>
  )
}

const PlaceholderRow = memo(PlaceholderRowUnmemoized)

try{ TablePagination.displayName ||= 'TablePagination' } catch {}
try{ PlaceholderRowUnmemoized.displayName ||= 'PlaceholderRowUnmemoized' } catch {}
try{ PlaceholderRow.displayName ||= 'PlaceholderRow' } catch {}